<script setup lang="ts">
const props = defineProps<{
  categoryId: string;
}>();

const route = useRoute();
const appState = useAppStateStore();
const categoryRouteSchedules = ref<Schedule | null>(null);
const isOfferActive = ref(false);
const countdownEnd = ref<string | undefined>(undefined);

const routeId = computed(() => {
  return route.path.split("/")[1] as "store" | "market" | "craft";
});

const hasStartDatePassed = (startDate: string) => {
  const startDateObj = new Date(startDate);
  const currentDate = new Date();
  return startDateObj < currentDate;
};

const initBanner = async () => {
  const merchantSchedules = appState.merchants.find(
    (game) => game.id === appState.currentMerchant
  )?.schedules;
  if (!merchantSchedules) return;
  const routeSchedule = merchantSchedules[routeId.value] || {};
  if (!routeSchedule) return;
  categoryRouteSchedules.value = routeSchedule[props.categoryId] || {};
  if (!categoryRouteSchedules.value) return;
  isOfferActive.value =
    categoryRouteSchedules.value.status === "ACTIVE" &&
    hasStartDatePassed(categoryRouteSchedules.value.startDate);
  countdownEnd.value = categoryRouteSchedules.value.endDate;
};

initBanner();
</script>
<template>
  <div
    v-if="isOfferActive"
    class="w-full p-4 bg-secondary-800 rounded-sm border border-secondary-500 flex flex-col xl:flex-row flex-wrap items-center justify-between gap-2 text-neutral-200">
    <div class="flex items-center gap-2">
      <NuxtIcon
        v-if="categoryRouteSchedules?.scheduleId === 'expiringLE'"
        name="mdi:clock-time-four-outline"
        class="shrink-0 w-8 h-8" />
      <h1 class="text-xl font-semibold text-center sm:text-start">
        {{ $t(`main.bannerOffers.${categoryRouteSchedules?.translationId}`) }}
      </h1>
    </div>
    <div class="flex flex-wrap justify-center items-center gap-2">
      <p class="text-primary-500 mt-0.5">
        {{ $t("main.bannerOffers.endsIn") }}
      </p>
      <ClientOnly>
        <CommonCountdown
          v-if="countdownEnd"
          class="text-xl font-semibold text-neutral-200"
          :datetime="countdownEnd"
          time-style="allUnits"
          @countdown-ended="isOfferActive = false" />
      </ClientOnly>
    </div>
  </div>
</template>
